// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + "51b36666" + ".chunk.css";
};